import {useSelector} from 'react-redux';
import {EqualHeight} from 'react-equal-height';
import DepositorSection from './depositorSection';
import CollectorSection from './collectorSection';
import AtDateDocumentNotifications from './atDateDocumentNotifications';
import authenticationService from '../../../services/authentication/AuthenticationService';

function ContentWrapperView() {
  const organisation = useSelector(state => state.organisation);
  const isExplorer = authenticationService.roles().isExplorer();
  const showDepositorSection = organisation.depositor && !isExplorer;

  return (
    <EqualHeight>
      <div className="row">
        {showDepositorSection &&
          <>
            <div className="col-12">
              <AtDateDocumentNotifications/>
            </div>
            <div className="col-12 col-lg-6">
              <DepositorSection/>
            </div>
          </>
        }
        <div className={`col-12${showDepositorSection ? ' col-lg-6' : ''}`}>
          <CollectorSection/>
        </div>
      </div>
    </EqualHeight>
  );
}

export default ContentWrapperView;
